/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.hero-banner' ).each( function( key, val ) {
        let image = $( this ).find( '.fit-image img' )[0];
        if ( $( this ).find( '.loop-video-container' ).length ) {
          image = $( this ).find( '.loop-video-container' )[0];
        }
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom top',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( image, {y: '10%', ease: 'linear'}, 0 );

        const pageId = $( this ).attr( 'data-id' );
        if ( !sessionStorage.getItem( 'us_' + pageId + '_alert_banner_dismissed', 'true' ) ) {
          $( val ).find( '.alert-banner' ).removeClass( 'is-hiding' );
        }

        $( this ).find( '.alert-banner .close-alert' ).click( function() {
          $( val ).find( '.alert-banner' ).addClass( 'is-hiding' );
          sessionStorage.setItem( 'us_' + pageId + '_alert_banner_dismissed', 'true' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
